import { PersonalInfoFormActionType } from "app/hooks/";
import { useCheckoutInfoContext } from "pages/checkout/providers/CheckoutInfoProvider";
import { useInfoFormErrorsContext } from "pages/checkout/providers/InfoFormErrorsProvider";
import FormGroup from "shared/ui/FormGroup";
import Input from "shared/ui/input";
import Label from "shared/ui/label";
import Phone from "shared/ui/phone";
import { concatClassnames } from "shared/utils/concatClassnames";

interface CheckoutInfoBusinessProps {
  className?: string;
}

const CheckoutInfoBusiness = ({ className }: CheckoutInfoBusinessProps) => {
  const { state, dispatch } = useCheckoutInfoContext();
  const { formErrors } = useInfoFormErrorsContext();

  const {
    companyName,
    contactFirstName,
    contactLastName,
    contactEmail,
    companyReference,
    companyPhoneNumber,
    btwNumber,
    vatNumber,
  } = state;

  const updateCompanyName = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_COMPANY_NAME,
      payload: e.target.value,
    });
  };
  const updateContactName = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_CONTACT_FIRST_NAME,
      payload: e.target.value,
    });
  };
  const updateContactSurname = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_CONTACT_LAST_NAME,
      payload: e.target.value,
    });
  };
  const updateContactEmail = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_CONTACT_EMAIL,
      payload: e.target.value,
    });
  };
  const updateCompanyReference = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_COMPANY_REFERENCE,
      payload: e.target.value,
    });
  };
  const updateCompanyPhoneNumber = (phone: string) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_COMPANY_PHONE_NUMBER,
      payload: phone,
    });
  };
  const updateBtw = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_BTW_NUMBER,
      payload: e.target.value,
    });
  };
  const updateVat = (e: any) => {
    dispatch({
      type: PersonalInfoFormActionType.UPDATE_VAT_NUMBER,
      payload: e.target.value,
    });
  };

  return (
    <div
      className={concatClassnames(
        "gg-grid gg-grid-cols-12 gg-gap-5",
        className,
      )}
    >
      <FormGroup
        className="gg-col-span-12"
        errorMessage={formErrors["companyName"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="companyName" className="gg-mb-1" required>
          Bedrijfsnaam
        </Label>
        <Input
          id="companyName"
          placeholder="Wat is de naam van je bedrijf?"
          value={companyName}
          onChange={updateCompanyName}
          error={!!formErrors["companyName"]}
          required
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12 md:gg-col-span-6 lg:gg-col-span-12"
        errorMessage={formErrors["contactFirstName"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="contactFirstName" className="gg-mb-1" required>
          Voornaam van contactpersoon
        </Label>
        <Input
          id="contactFirstName"
          placeholder="Voornaam van contactpersoon?"
          value={contactFirstName}
          onChange={updateContactName}
          error={!!formErrors["contactFirstName"]}
          required
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12 md:gg-col-span-6 lg:gg-col-span-12"
        errorMessage={formErrors["contactLastName"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="contactLastName" className="gg-mb-1" required>
          Achternaam van contactpersoon
        </Label>
        <Input
          id="contactLastName"
          placeholder="Achternaam van contactpersoon?"
          value={contactLastName}
          onChange={updateContactSurname}
          error={!!formErrors["contactLastName"]}
          required
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12"
        errorMessage={formErrors["contactEmail"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="contactEmail" className="gg-mb-1" required>
          Email van contactpersoon
        </Label>
        <Input
          id="contactEmail"
          placeholder="Email van contactpersoon?"
          value={contactEmail}
          onChange={updateContactEmail}
          error={!!formErrors["contactEmail"]}
          required
        />
      </FormGroup>

      <FormGroup className="gg-col-span-12">
        <Label htmlFor="reference" className="gg-mb-1">
          Referentie
        </Label>
        <Input
          id="reference"
          value={companyReference}
          onChange={updateCompanyReference}
          placeholder="Referentie?"
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12"
        errorMessage={formErrors["companyPhoneNumber"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="companyPhoneNumber" className="gg-mb-1" required>
          Telefoonnummer
        </Label>
        <Phone
          id="companyPhoneNumber"
          value={companyPhoneNumber}
          error={!!formErrors["companyPhoneNumber"]}
          onChange={(phone: string) => {
            updateCompanyPhoneNumber(phone);
          }}
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12 md:gg-col-span-6 lg:gg-col-span-12"
        errorMessage={formErrors["btwNumber"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="btw" className="gg-mb-1">
          BTW-nummer
        </Label>
        <Input
          id="btw"
          value={btwNumber}
          onChange={updateBtw}
          placeholder="BTW-nummer?"
          error={!!formErrors["btwNumber"]}
        />
      </FormGroup>

      <FormGroup
        className="gg-col-span-12 md:gg-col-span-6 lg:gg-col-span-12"
        errorMessage={formErrors["vatNumber"]}
        displayError={state.isSubmitting}
      >
        <Label htmlFor="kvk" className="gg-mb-1" required>
          KvK-nummer
        </Label>
        <Input
          id="kvk"
          value={vatNumber}
          onChange={updateVat}
          readOnly={!!window.vo?.kvk}
          placeholder="KvK-nummer?"
          error={!!formErrors["vatNumber"]}
          required
        />
      </FormGroup>
    </div>
  );
};
export default CheckoutInfoBusiness;
